import React, { useEffect } from "react";
import "./index.css";
import { Form, Input, Button, Typography, message } from "antd";
import { Redirect } from "react-router-dom";
import { DocumentTitle, AuthForm } from "../../components";
import { useQuery } from "../../hooks";
import I18n from "../../i18n";
import { logger } from "../../../utils";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import {
  checkIsRegistered,
  setPhoneNumber,
} from "../../../application/login-register-slice";

const { Paragraph } = Typography;
const { Item, useForm } = Form;

export default function LoginRegister() {
  const dispatch = useAppDispatch();
  const { phoneNumber, isRegistered, loading } = useAppSelector(
    (state) => state.loginRegister
  );
  const [form] = useForm();
  const query = useQuery();

  const submit = async () => {
    try {
      await form.validateFields();
      dispatch(checkIsRegistered());
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    if (loading === "failed") message.error(I18n.general.networkError);
  }, [loading]);

  if (loading === "succeeded") {
    const back = query.get("back");
    if (isRegistered === true) {
      return <Redirect to={`/login-auth/${phoneNumber}?back=${back}`} />;
    } else if (isRegistered === false) {
      return (
        <Redirect to={`/verify-code/register/${phoneNumber}?back=${back}`} />
      );
    }
  }

  return (
    <DocumentTitle title={I18n.loginRegister.phoneInputTitle}>
      <AuthForm
        title={I18n.title}
        subtitle={I18n.loginRegister.phoneInputTitle}
        description={I18n.loginRegister.description}
      >
        <Form
          form={form}
          onFinish={submit}
          fields={[{ name: "phone-number", value: phoneNumber }]}
        >
          <Item
            name="phone-number"
            rules={[
              {
                required: true,
                message: I18n.loginRegister.phoneEmptyError,
                validateTrigger: "onSubmit",
              },
              {
                min: 11,
                max: 11,
                len: 11,
                message: I18n.loginRegister.phoneInvalidError,
                validateTrigger: "onSubmit",
              },
            ]}
          >
            <Input
              required={true}
              inputMode="tel"
              placeholder={I18n.general.phoneNumber}
              disabled={loading === "pending"}
              maxLength={11}
              spellCheck={false}
              allowClear
              onChange={(value) => {
                dispatch(setPhoneNumber(value.target.value));
                form.setFields([{ name: "phone-number", value: phoneNumber }]);
              }}
            />
          </Item>
          <Item>
            <Button
              type="primary"
              block
              onClick={submit}
              loading={loading === "pending"}
            >
              {I18n.general.continue}
            </Button>
          </Item>
        </Form>
        <Paragraph className="login-register-form-terms-notice">
          با ورود و یا ثبت نام در مزون بهارا شما{" "}
          <a href="/terms">{I18n.general.termsAndConditions}</a> استفاده از
          سرویس‌های سایت مزون بهارا و{" "}
          <a href="/privacy-policy">{I18n.general.privacyPolicy}</a> آن را می
          پذیرید.
        </Paragraph>
      </AuthForm>
    </DocumentTitle>
  );
}
